
import LogInModal from "flarum/components/LogInModal";

export default function navigationOptionRedirect(key){
  if(app.session.user){
    if(key==="item0"){
      showDecorationStore();
    }else if(key==="item1"){
      showPurchaseEquipment();
    }else if(key==="item2"){
      showPurchaseHistory();
    }
  }else{
    app.modal.show(LogInModal);
  }
}

function showDecorationStore() {
  m.route.set(app.route("decorationStore"));
}

function showPurchaseEquipment() {
  m.route.set(app.route("user.decorationStoreEquipment", {
    username: app.session.user.username(),
  }));
}

function showPurchaseHistory() {
  m.route.set(app.route("user.decorationStorePurchase", {
    username: app.session.user.username(),
  }));
}